import { find, map, filter } from 'lodash-es'
import {
  CUSTOM,
  MENU_TYPE,
  MENU_STRUCTURE,
  MENU,
  MENU_LIST,
  SECTION_LIST,
  DISH_LIST,
  GLOBAL,
} from '../../../constants'

const scrapingTestCaseTagsFormInitialValues = data => {
  const customTagIds = map(
    filter(data, ({ type }) => type === CUSTOM),
    'id',
  )

  const menuType = find(data, ({ type }) => type === MENU_TYPE)?.name

  const menuStructure = find(data, ({ type }) => type === MENU_STRUCTURE)?.name

  const menu = map(
    filter(data, ({ type }) => type === MENU),
    'name',
  ).join(', ')

  const menuList = map(
    filter(data, ({ type }) => type === MENU_LIST),
    'name',
  ).join(', ')

  const sectionList = map(
    filter(data, ({ type }) => type === SECTION_LIST),
    'name',
  ).join(', ')

  const dishList = map(
    filter(data, ({ type }) => type === DISH_LIST),
    'name',
  ).join(', ')

  const global = map(
    filter(data, ({ type }) => type === GLOBAL),
    'name',
  ).join(', ')

  return {
    customTagIds,
    menuType,
    menuStructure,
    menu,
    menuList,
    sectionList,
    dishList,
    global,
  }
}

export default scrapingTestCaseTagsFormInitialValues
